// import $ from 'jquery';

// import SinglePageUpdown from './single-page-updown';

import jQueryEasing from '../vendors/jquery.easing.1.3.js';
import scrollify from '../vendors/jquery.scrollify';
// import scrollOverflow from  '../vendors/scrolloverflow.min';
import fullpage from '../vendors/jquery.fullpage';

// import 'jquery.easing';

import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class HomeScroller {
	
	constructor() {

		if( $(".home-scroller").length < 1 ) {
			$(window).off('scroll.handleIsInViewport');
			$('body').removeClass('hero-in-viewport');
			return false;
		}

		this.isHeroInViewport = 'notset';
		this.isPortfolioInViewport = false;

		this.setScrollerHeights();
		this.setScrollerDuration();
		this.resizeEvents();
		this.checkScrollers();
		this.isHeroVisible();

		if( !this.is_touch_device() ) {
			// this.parallaxScroll();
			// this.sliderSnap();
		}
		else {
			$(".home-scroller").addClass('home-scroller--touch-screen');
		}

		this.sliderBullet();
		this.doScrollToPortfolio();
	}

	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	setScrollerHeights() {
		var self = this;
		var viewportHeight = this.is_touch_device() ? window.screen.height : $(window).outerHeight();
		$(".home-scroller__item-inner").height(viewportHeight);
		$(window).on('resize', function(){
			viewportHeight = self.is_touch_device() ? window.screen.height : $(window).outerHeight();
			$(".home-scroller__item-inner").height(viewportHeight);
		})
	}

	setScrollerDuration() {
		this.slideHeightDuration = $(window).height() * 4 - 540;
	}

	resizeEvents() {
		var self = this;
		$(window).on('resize', function(){
			self.slideHeightDuration = $(window).height() * 4 - 540;
		});
	}

	fullpageSnap() {
		$(document).ready(function() {
			$('.home-scroller__list').fullpage({
				scrollOverflow:true,
				hybrid:true
			});
		});
	}

	sliderSnap() {
		var self = this;
		var isActive = true;

		this.scrollify = $.scrollify({
			section : ".home-snapper",
			updateHash: false,
			setHeights: false,
			scrollSpeed: 900,
			easing: 'easeOutQuad',
			// interstitialSection: '.bjzm-wrapper',
			before: function(index, sections)  {
				var bulletIndex = index + 1;
				var $bullet = $('.bullet-item:nth-child('+bulletIndex+')');
				$(".bullet").removeClass('active');
				$bullet.find('a').addClass('active');
			},
			after: function(index, sections) {
				if( index == ( sections.length - 1 ) ) {
					if( isActive ) {
						console.log('disable');
						$.scrollify.disable();
						isActive = false;
					}
				}
				else {
					if( !isActive ) {
						$.scrollify.enable();
						isActive = true;
					}
				}
			}
		});
	}

	doScrollToPortfolio() {
		this.scrollifyEnabled = true;
		var self = this;
		$(".cta-wrapper .cta").on('click', function(e){
			e.preventDefault();
			console.log('scroll');
			
			if(history.pushState) {
				// history.pushState(null, null, '#portfolio-section');
			}
			else {
				// location.hash = '#portfolio-section';
			}

			$('html, body').animate({ scrollTop: $('#portfolio-section').offset().top}, 700 );
			
			$('.riocan-page-animation').addClass('fade-out');
			$.scrollify.disable();
			this.scrollifyEnabled = false;

			setTimeout(function(){
				// $('html, body').scrollTop($('#portfolio-section').offset().top );
				// $('#portfolio-section').addClass('content-home--fade-in-up');
			}, 700);

			setTimeout(function(){
				// $('.riocan-page-animation').removeClass('fade-out');
			}, 900);

			setTimeout(function(){
				// $('#portfolio-section').removeClass('content-home--fade-in-up');
			}, 1600);

			setTimeout(function(){
				// $('#portfolio-section').removeClass('content-home--fade-in-up');
				self.enableScrollifyAfterScroll();
			}, 1900);

		});
	}

	enableScrollifyAfterScroll() {

		$(window).on('scroll', function(){
			if( !this.scrollifyEnabled ) {
				this.scrollifyEnabled = true;
				// $.scrollify.enable();
			}
		})

	}

	sliderBullet() {
		var self = this;
		/*this.subMenuScroll = new SinglePageUpdown({
			container: $(".bullet-list"),
			changeHash: false,
			activeClass: 'active',
			beforeScroll: function(anchor) {
				$.scrollify.disable();
			},
			callBack: function() {
				$.scrollify.enable();
			}

		});*/
		
	}

	isHeroVisible() {

		//WORKING ON SHOWING 
		$.fn.isInViewport = function(entireElement = true, offset = 0) {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
		    // var elementBottom = elementTop;
		    // elementBottom += entireElement ? $(this).outerHeight() : 0;

		    var viewportTop = $(window).scrollTop();
		    var viewportBottom = viewportTop + $(window).height();


		    if( entireElement ) {
		    	return elementBottom > ( viewportTop + offset ) && elementTop < viewportBottom;
		    }
		    else {
		    	return elementTop < ( viewportBottom - offset );
		    }
		};

		//ON WINDOW LOAD, RESIZE OR SCROLL DO THE FOLLOW

		// this.isHeroInViewport = false;
		var $header = $(".header");

		var self = this;
		setTimeout(function(){
			self.handleIsInViewport();
		}, 1100);


		$(window).on('scroll.handleIsInViewport', function() {
			self.handleIsInViewport();
		});
	}

	handleIsInViewport() {

		if ($('#hero').isInViewport(true, 80)) {
			if( !this.isHeroInViewport || this.isHeroVisible != 'notset' ) {
				$("body").addClass("hero-in-viewport");
				this.isHeroInViewport = true;
			} 
		} 
		else {
			if( this.isHeroInViewport ) {
				$("body").removeClass("hero-in-viewport");
				this.isHeroInViewport = false;
			}    
		}


		if ($('#portfolio-section').isInViewport(false, 200)) {
			if( !this.isPortfolioInViewport ) {
				$("body").addClass("portfolio-in-viewport");
				this.isPortfolioInViewport = true;
			} 

		} 
		else {
			if( this.isPortfolioInViewport ) {
				$("body").removeClass("portfolio-in-viewport");
				this.isPortfolioInViewport = false;
			}    

		}

	}

	checkScrollers() {
		this.scrollMagicController = new ScrollMagic.Controller();
	}

	parallaxScroll() {
		var controller = new ScrollMagic.Controller();
		var self = this;
		$(".home-scroller__item-inner").each( function () {
			
			var $backgroundImage = $(this).find(".home-scroller__background-image");
			var $text = $(this).find(".home-scroller__background-image").siblings('.home-scroller__content');
			
			var parallaxEffect = TweenMax.from( $backgroundImage, 1, {
				y: '-50%',
				ease: Power0.easeNone
			} );

			var textPosition = TweenMax.fromTo( $text, 1, 
			{
					y: '-500',	// moving slower than scroll
					//y: '300',	// moving faster than scroll
					ease: 'none',
				},
				{
					y: '500',	// moving slower than scroll
					//y: '-300',	// moving faster than scroll
					ease: 'none'
				},
				);

			var textFadeIn = TweenMax.to( $text, 1, 
				{
					opacity: '1',
					ease: 'none'
				},
			);
			var textFadeOut = TweenMax.to( $text, 1, 
				{
					opacity: '0',
					ease: 'none'
				},
			);


			var $slide = this;


			var slideHeightDuration = $(this).height() * 4 - 540;

			var parallaxScene = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: 1,
				duration: '200%',
			})
			.setTween( parallaxEffect )
			.addTo(controller);

			var textPositionScene = new ScrollMagic.Scene({
				triggerElement: $slide,
				duration: self.slideHeightDuration,
				triggerHook: 'onEnter'
			})
			.setTween( textPosition )
			.addTo(controller);

			var textFadeInScene = new ScrollMagic.Scene({
				triggerElement: this,
				// duration: 100,
				duration: '30%',
				triggerHook: 0.4,
				// offset: 200,
			})
			.setTween( textFadeIn )
			.addTo(controller);

			var textFadeOutScene = new ScrollMagic.Scene({
				triggerElement: this,
				// duration: 100,
				duration: '30%',
				triggerHook: -0.6,
				// offset: 600,
			})
			// .addIndicators()
			.setTween( textFadeOut )
			.addTo(controller);

		});
	}

}

module.exports = HomeScroller;